module.exports = do ->
   _ = require("underscore").default
   EverTrue = require("app")
   {createStore} = require("@evertrue/et-flux")
   SubscriptionPrefSource = require("apps/filters/sources/subscription-pref-source").default
   ListSource = require("apps/lists/sources/list-source")

   _formatListKey = (id) -> "list:#{id}:"
   _getDefaultPreferences = (enabled) ->
      email_enabled: enabled
      email_frequency: "weekly"
      push_enabled: enabled
      push_frequency: "weekly"


   createStore "SubscriptionPrefStore",
      getInitialState: ->
         preferences: {}
         loaded: false

      registerActions: ->
         @on SubscriptionPrefSource.actions.fetchedPreferences, @respondToFetched
         @on SubscriptionPrefSource.actions.failedPreferences, @respondToFetchFailure
         @on SubscriptionPrefSource.actions.updatedPreference, @respondToUpdate
         @on SubscriptionPrefSource.actions.deletedPreference, @respondToDelete

         @on ListSource.actions.createdList, @respondToNewList
         @on ListSource.actions.updatedList, @respondToNewList
         @on ListSource.actions.deletedList, @respondToDeleteList

      respondToFetched: (preferences) ->
         prefs = $.extend(true, {}, @getState("preferences"))
         _.each preferences, (pref) ->
            prefs[pref.key] = pref
         @setState {preferences: prefs, loaded: true}

      # The initial fetch failed outright (as opposed to succeeding with no rows).
      # Mark loaded anyway so getBySegmentId falls through to safe both-disabled
      # defaults instead of returning undefined forever (SIG-853).
      respondToFetchFailure: ->
         @setState {loaded: true}

      respondToUpdate: (preference) ->
         prefs = $.extend(true, {}, @getState("preferences"))
         prefs[preference.key] = preference
         @setState {preferences: prefs}

      respondToDelete: (key) ->
         @setState {preferences: _.omit @getState("preferences"), key}

      respondToNewList: (list) ->
         if list.preferences && list.id != "temp"
            key = _formatListKey(list.id)
            prefs = _.extend {}, _.omit(list.preferences, "key"), label: list.name
            SubscriptionPrefSource.update(key, prefs)

      respondToDeleteList: (list_id) ->
         key = _formatListKey(list_id)
         if @getState("preferences")[key]
            SubscriptionPrefSource.delete(key)

      api:
         getByKey: (key) ->
            @getState("preferences")[key]

         # For an existing segment, return any preference already in the store (including
         # a freshly-written one from respondToUpdate), then withhold a result until the
         # initial fetch has resolved rather than falling back to disabled defaults.
         # Callers previously treated "not loaded yet" the same as "no preferences
         # saved" and could write that disabled-default placeholder over a user's real
         # notification settings.
         getBySegmentId: (id) ->
            if id
               pref = @getByKey(_formatListKey(id))
               return pref if pref
               return undefined unless @getState("loaded")
               _getDefaultPreferences(false)
            else _getDefaultPreferences(true)

         getDefaultPreferences: ->
            _getDefaultPreferences(true)
